export const GET_COST_HEADS = "GET_COST_HEADS";
export const GET_COST_HEAD = "GET_COST_HEAD";
export const ADD_COST_HEAD = "ADD_COST_HEAD";
export const DELETE_COST_HEAD = "DELETE_COST_HEAD";
export const UPDATE_COST_HEAD = "UPDATE_COST_HEAD";
